import { Pipe, PipeTransform } from "@angular/core";
import { ProjectEvent } from "src/app/services/response-models/events.response.model";
import moment from "moment";
import { TranslateService } from "@ngx-translate/core";
import { firstValueFrom } from "rxjs";

@Pipe({
    name: "eventTime",
    standalone: false,
})
export class EventTimePipe implements PipeTransform {
    constructor(private translateSerice: TranslateService) {}

    async transform(value: ProjectEvent, date: string) {
        const groupDate = moment(new Date(date));
        const start = moment(value.start);
        const end = moment(value.end);

        const startTime = `${this.checkNumberLength(start.hours())}:${this.checkNumberLength(
            start.minutes()
        )}`;
        const endTime = `${this.checkNumberLength(end.hours())}:${this.checkNumberLength(
            end.minutes()
        )}`;

        // if event is crossing days partly
        if (groupDate.diff(end.startOf("day")) === 0 && value.partial) {
            return `00:00 - ${endTime}`;
        }

        // If event is full day
        if (
            (startTime === "00:00" && endTime === "00:00") ||
            start.startOf("days").diff(end.startOf("days"), "days") !== 0
        ) {
            const translation = await firstValueFrom(this.translateSerice.get("EVENT"));
            return translation.ALL_DAY;
        }

        // Anything else
        return `${startTime} - ${endTime}`;
    }

    private checkNumberLength = (number: number) => {
        if (number < 10) {
            return `0${number}`;
        }

        return number.toString();
    };
}
